import { Component } from "react";
import { withRouter } from "react-router-dom";

import { revalidateSessionValidity } from "../../utils/sessionValidity";

/**
 * Renders nothing. Its only job is to re-run the isStudentUserValid check when
 * the route changes.
 *
 * The 52 components that read that check are now `cache-first`, so they no
 * longer each fetch it — which is the point, but it also means nothing would
 * ever notice a session going invalid mid-visit. This sits inside the Router in
 * App.js, above the Switch, so it survives every route change and can watch
 * them; `revalidateSessionValidity` throttles the actual requests and writes
 * into the shared cache entry the HOCs are already watching.
 */
class SessionValidityWatcher extends Component {
    componentDidMount() {
        revalidateSessionValidity();
    }

    componentDidUpdate(prevProps) {
        if (prevProps.location.pathname !== this.props.location.pathname) {
            revalidateSessionValidity();
        }
    }

    render() {
        return null;
    }
}

export default withRouter(SessionValidityWatcher);
